export default __webpack_public_path__ + "static/media/reportLogo.9c604bdc.png";